import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import axios from 'axios';

const YearlyPratibedan = () => {

    axios.defaults.withCredentials = true;

    const [yReportList, setyReportList] = useState([]);

    const fetchYReports = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/yearly-report`);
            if (response.data.status === "Success") {
                setyReportList(response.data.reportDetail)
            }
            else {
                console.error("Unable to get data!", response.data.errorDetail);
            }
        }
        catch (error) {
            console.error("Error fetching reports:", error)
        }
    }

    const sortYReport = yReportList.sort((a, b) => b.ID - a.ID);
    // yReportList.sort((a, b) => {
    //     // Assuming year is a string, convert it to a number for comparison
    //     return Number(b.id) - Number(a.id);
    // });

    const handleOpenPdf = (data) => {
        const pdfUrl = `${process.env.REACT_APP_IMG_URL}/reports/yearlyreport/${data}`;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        link.click();
    }

    useEffect(() => {
        fetchYReports();
    }, [])

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='report-body'>
                    <div className='report-header'>
                        <h3>वाषिर्क प्रतिवेदन</h3>
                    </div>
                    <div className='bg-white rounded shadow report-table-body'>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>S.N.</th>
                                    <th>Title</th>
                                    <th>Year</th>
                                    <th>Detail</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortYReport.length > 0 ? (
                                    sortYReport.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{item.Title}</td>
                                            <td>{item.FiscalYear}</td>
                                            <td>
                                                <button
                                                    className='show-button'
                                                    onClick={() => handleOpenPdf(item.PdfUrl)}
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4}>No Record Found In Server!</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default YearlyPratibedan